/**
 * The ServiceGateway API
 * The ServiceGateway provides APIs to interact with the Gintel Easy Business Communications Suite (EBCS)
 *
 * OpenAPI spec version: 1.14.31-SNAPSHOT
 * Contact: frank.paaske@gintel.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AddTerminalResponse } from '../model/addTerminalResponse';
import { GetOrganizationResponse } from '../model/getOrganizationResponse';
import { GetTrunksResponse } from '../model/getTrunksResponse';
import { Response } from '../model/response';
import { SearchOrganizationResponse } from '../model/searchOrganizationResponse';
import { ServiceNumberDataResponse } from '../model/serviceNumberDataResponse';
import { Terminal } from '../model/terminal';
import { TerminalsResponse } from '../model/terminalsResponse';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { DirectoryV2ServiceInterface }                            from './directoryV2.serviceInterface';


@Injectable()
export class DirectoryV2Service implements DirectoryV2ServiceInterface {

    protected basePath = 'http://localhost:8080/ServiceGateway/rest';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addTerminal1(organization?: string, login?: string, body?: Terminal, observe?: 'body', reportProgress?: boolean): Observable<AddTerminalResponse>;
    public addTerminal1(organization?: string, login?: string, body?: Terminal, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AddTerminalResponse>>;
    public addTerminal1(organization?: string, login?: string, body?: Terminal, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AddTerminalResponse>>;
    public addTerminal1(organization?: string, login?: string, body?: Terminal, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<AddTerminalResponse>(`${this.basePath}/directory/v2/terminals`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public editTerminal1(organization?: string, login?: string, body?: Terminal, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public editTerminal1(organization?: string, login?: string, body?: Terminal, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public editTerminal1(organization?: string, login?: string, body?: Terminal, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public editTerminal1(organization?: string, login?: string, body?: Terminal, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Response>(`${this.basePath}/directory/v2/terminals`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getOrganization2(organization?: string, observe?: 'body', reportProgress?: boolean): Observable<GetOrganizationResponse>;
    public getOrganization2(organization?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetOrganizationResponse>>;
    public getOrganization2(organization?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetOrganizationResponse>>;
    public getOrganization2(organization?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetOrganizationResponse>(`${this.basePath}/directory/v2/organization`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param serviceNumber 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getServiceNumberData1(organization?: string, serviceNumber?: string, observe?: 'body', reportProgress?: boolean): Observable<ServiceNumberDataResponse>;
    public getServiceNumberData1(organization?: string, serviceNumber?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ServiceNumberDataResponse>>;
    public getServiceNumberData1(organization?: string, serviceNumber?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ServiceNumberDataResponse>>;
    public getServiceNumberData1(organization?: string, serviceNumber?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (serviceNumber !== undefined && serviceNumber !== null) {
            queryParameters = queryParameters.set('serviceNumber', <any>serviceNumber);
        }

        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<ServiceNumberDataResponse>(`${this.basePath}/directory/v2/serviceNumberData`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTerminals1(organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<TerminalsResponse>;
    public getTerminals1(organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TerminalsResponse>>;
    public getTerminals1(organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TerminalsResponse>>;
    public getTerminals1(organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (login !== undefined && login !== null) {
            queryParameters = queryParameters.set('login', <any>login);
        }

        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<TerminalsResponse>(`${this.basePath}/directory/v2/terminals`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTrunks1(observe?: 'body', reportProgress?: boolean): Observable<GetTrunksResponse>;
    public getTrunks1(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetTrunksResponse>>;
    public getTrunks1(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetTrunksResponse>>;
    public getTrunks1(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetTrunksResponse>(`${this.basePath}/directory/v2/trunks`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param fullNumber 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public removeTerminal1(fullNumber: string, organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public removeTerminal1(fullNumber: string, organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public removeTerminal1(fullNumber: string, organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public removeTerminal1(fullNumber: string, organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (fullNumber === null || fullNumber === undefined) {
            throw new Error('Required parameter fullNumber was null or undefined when calling removeTerminal1.');
        }



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.delete<Response>(`${this.basePath}/directory/v2/terminals/${encodeURIComponent(String(fullNumber))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param organizationId 
     * @param organizationName 
     * @param entriesPerPage 
     * @param page 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public searchOrganization2(organization?: string, organizationId?: string, organizationName?: string, entriesPerPage?: number, page?: number, observe?: 'body', reportProgress?: boolean): Observable<SearchOrganizationResponse>;
    public searchOrganization2(organization?: string, organizationId?: string, organizationName?: string, entriesPerPage?: number, page?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SearchOrganizationResponse>>;
    public searchOrganization2(organization?: string, organizationId?: string, organizationName?: string, entriesPerPage?: number, page?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SearchOrganizationResponse>>;
    public searchOrganization2(organization?: string, organizationId?: string, organizationName?: string, entriesPerPage?: number, page?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (organizationId !== undefined && organizationId !== null) {
            queryParameters = queryParameters.set('organizationId', <any>organizationId);
        }
        if (organizationName !== undefined && organizationName !== null) {
            queryParameters = queryParameters.set('organizationName', <any>organizationName);
        }
        if (entriesPerPage !== undefined && entriesPerPage !== null) {
            queryParameters = queryParameters.set('entriesPerPage', <any>entriesPerPage);
        }
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }

        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<SearchOrganizationResponse>(`${this.basePath}/directory/v2/searchorganization`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
